const INVOICE_STATUSES = [
  { value: '-', primaryText: 'Unfiltered', label: 'Status: Unfiltered' },
  { value: 3, primaryText: 'Posted', label: 'Status: Posted' },
  { value: 2, primaryText: 'Flagged', label: 'Status: Flagged' },
  { value: 1, primaryText: 'Ignore', label: 'Status: Ignore' },
  { value: 0, primaryText: 'Open', label: 'Status: Open' }
];

export default INVOICE_STATUSES;



// WEBPACK FOOTER //
// ./src/components/viewTransactions/viewTransactionsGrid/c/invoiceStatusSelector/InvoiceStatuses.js